import React, { FC } from "react";
import { Divider } from "antd";
import { ApplicationCommission } from "./ApplicationCommission/ApplicationCommission";
import { OfferDocuments } from "./OfferDocuments/OfferDocuments";

export const Offer: FC = () => {
  return (
    <section>
      <Divider orientation="left" orientationMargin={0}>
        <h3>Блок формирования предложения</h3>
      </Divider>
      <ApplicationCommission />
      <Divider orientation="left" orientationMargin={0}>
        <h3>Документы предложения</h3>
      </Divider>
      <OfferDocuments />
    </section>
  );
};
